import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { MMPlayerBlockAttsInterface } from '~/types/AppData/Blocks/MMPlayerBlockInterface';
import VideoPlayerEmbed from '~/components/Shared/Video/VideoPlayerEmbed';

export default component$((value: MMPlayerBlockAttsInterface): JSX.Element => {
  if (!value.html) {
    return <></>;
  }

  // If we eventually try to merge the VideoPlayerEmbed with the VideoPlayer component here,
  // make sure the video would not be blocked by the no-video-player commercial tag
  return <VideoPlayerEmbed html={value.html} version={value.version} />;
});
